@if (!!eligibleDates?.length) {
  <div class="flex justify-between items-center mb-4">
    <label class="font-semibold mr-1">Therapy Minutes for Week {{ currentPeriod?.weekNumber }}:</label>
    @if (canEdit) {
      <div>
        <button
          pButton
          type="button"
          label="Discard Changes"
          class="p-button-secondary"
          [disabled]="!therapyForm?.dirty || isLoading"
          (click)="discardChanges()"
        ></button>
        <button
          class="ml-2"
          pButton
          type="button"
          label="Save Changes"
          [disabled]="!therapyForm?.dirty || therapyForm.invalid"
          [loading]="isLoading"
          (click)="saveChanges()"
        ></button>
      </div>
    }
  </div>
  @if (suggestLevelMessage) {
    <p-message [value]="suggestLevelMessage" [closable]="false" severity="info" icon="pi pi-info-circle">
      <p class="font-semibold">{{ suggestLevelMessage.summary }}</p>
      <p>{{ suggestLevelMessage.detail }}</p>
    </p-message>
  }
  <form [formGroup]="therapyForm">
    <div formArrayName="therapies">
      <p-table
        [columns]="cols"
        [value]="therapies.controls"
      >
        <ng-template let-columns pTemplate="header">
          <tr>
            @for (column of cols; track column) {
              <th
                [style]="{ 'width': column.width }"
              >
                @switch (column.header) {
                  @case ('Discipline') {
                    {{ column.header }}
                  }
                  @default {
                    {{ column.header | utcDateWithoutTimeZone: 'MM/dd/yyyy' }}
                  }
                }
              </th>
            }
          </tr>
        </ng-template>
        <ng-template let-therapy let-rowIndex="rowIndex" pTemplate="body">
          <tr [formGroupName]="rowIndex">
            @for (column of cols; track column) {
              <td
                [pEditableColumn]="therapy.value[column.field]"
                [pEditableColumnField]="column.field"
                [pEditableColumnDisabled]="!canEdit || isLoading"
              >
                @switch (column.field) {
                  @case ('disciplineName') {
                    {{ therapy.value.disciplineName }}
                  }
                  @default {
                    <p-cellEditor class="truncate-child relative">
                      <ng-template pTemplate="input" [formGroupName]="column.field">
                        <p-inputNumber
                          inputStyleClass="w-full"
                          formControlName="timeSpent"
                          [min]="0"
                          [max]="1440"
                          (onBlur)="getTotalMinutes()"
                          (onInput)="onInputMinutes(therapy.get(column.field))" />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ therapy.value[column.field]?.timeSpent || 0 }}
                      </ng-template>
                    </p-cellEditor>
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
        <ng-template let-therapy pTemplate="footer">
          <tr>
            @for (column of cols; track column) {
              <td
                class="regular-background"
              >
                @switch (column.field) {
                  @case ('disciplineName') {
                    Total
                  }
                  @default {
                    {{ totalMinutes[column.field] }}
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
} @else {
  <p-message id="empty-week-message" severity="info" icon="pi pi-info-circle" [closable]="false">
    <p class="font-semibold">{{ missedDaysMessage.summary }}</p>
    <p>{{ missedDaysMessage.detail }}</p>
  </p-message>
}

